module.exports = "<ul class=\"custom-list custom-list--entities\"> <li data-ng-repeat=\"entity in $ctrl.entities\"> <div class=entity-label ui-sref-active=is-active ui-sref={{$ctrl.entityState}}> <div class=entity-label__content> <span class=entity-label__name data-ng-bind=entity.name></span> </div> <span flex></span> <div class=entity-label__info> </div> </div> </li> </ul> ";


//////////////////
// WEBPACK FOOTER
// ./app/common/entities-list/list.html
// module id = RYK1
// module chunks = 1